import React, { FC } from 'react'

import * as SC from './styled'

export type TextProps = {
  className?: string
  text: string
  centered: boolean
}

const Text: FC<TextProps> = (props) => {
  const { className, text } = props

  return (
    <SC.Container className={className}>
      <SC.Text>{text}</SC.Text>
    </SC.Container>
  )
}

export default Text
